import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'janico',
} as IModuleProps;
